import { render } from "./shinsei_Kyushokunegaiedit.vue?vue&type=template&id=4aef4caa&scoped=true&ts=true"
import script from "./shinsei_Kyushokunegaiedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Kyushokunegaiedit.vue?vue&type=script&lang=ts"

import "./shinsei_Kyushokunegaiedit.vue?vue&type=style&index=0&id=4aef4caa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aef4caa"]])

export default __exports__